import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const insightsPortalFlyersAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.Flyers],
    featureToggles: [FeatureToggle.InsightsPortalFlyersDashboard],
  },
]
